import React from 'react';
import type { components } from '../../../../types/learnerApi';

type Config = components['schemas']['SanitizedShortAnswerConfig'];

export interface ShortAnswerValue {
  text: string;
}

export interface ShortAnswerViewProps {
  item: { id: string; points?: number; config: Config };
  mode: 'learner' | 'preview';
  value?: ShortAnswerValue;
  onChange?: (value: ShortAnswerValue) => void;
  disabled?: boolean;
}

const ShortAnswerView: React.FC<ShortAnswerViewProps> = ({
  item,
  mode,
  value,
  onChange,
  disabled,
}) => {
  return (
    <div className="space-y-3">
      <p className="font-medium text-text-primary">{item.config.question}</p>
      <input
        type="text"
        value={value?.text ?? ''}
        onChange={(e) => {
          if (disabled || mode === 'preview') return;
          onChange?.({ text: e.target.value });
        }}
        disabled={disabled}
        placeholder="Your answer…"
        className="w-full px-3 py-2 rounded-lg border border-border-primary dark:border-white/15 bg-white dark:bg-white/[0.04] text-text-primary placeholder:text-text-tertiary text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:opacity-60"
      />
      {item.points != null && (
        <p className="text-xs text-text-tertiary">{item.points} pt{item.points !== 1 ? 's' : ''}</p>
      )}
    </div>
  );
};

export default ShortAnswerView;
